<div *ngIf="model.queryRunning$ | async" class="grid-loader">
    <fui-ellipsis-loader></fui-ellipsis-loader>
</div>
<div class="piv-grid-header">
    <fui-commands [icon]="'hamburger'" [title]="'wbo.bi-pivot-grid.option.grid-options.label' | translate"
                  [popAlignment]="PopParentHorizontalAlignment.RIGHT">
        <fui-command (click)="model.hideDimensions()" *ngIf="model.showDimension"
                     [title]="'wbo.bi-pivot-grid.option.grid-options.hide-field-names'"></fui-command>
        <fui-command (click)="model.showDimensions()" *ngIf="!model.showDimension"
                     [title]="'wbo.bi-pivot-grid.option.grid-options.show-field-names'"></fui-command>
        <fui-command (click)="model.downloadExcel()"
                     [title]="'wbo.bi-pivot-grid.option.grid-options.download'"></fui-command>
    </fui-commands>
</div>

<div class="piv-grid-pane" [ngStyle]="{'height.px': height}">
    <div *ngIf="model.data" class="piv-grid">
        <ng-container *ngFor="let i of model.data.columnHeadingDepth; trackBy: trackByFn">
            <div
                *ngIf="!model.data.colHeadings[0][i].isMeasure && (model.showDimension || model.data.colHeadings[0][i].index !== 0 || (!model.data.colHeadings[0][i + 1] || model.data.colHeadings[0][i + 1].index === 0 || model.data.colHeadings[0][i + 1].isSummary))"
                class="piv-grid-row">

                <ng-container *ngFor="let r of model.data.rowHeadingDepth; trackBy: trackByFn; let i = index">
                    <div
                        *ngIf="model.showDimension || i < model.data.rowHeadingDepth.length - model.data.openRowHeadingCount"
                        class="piv-grid-row-col-heading"
                        [class.blank-summary]="r === (model.showDimension ? model.data.rowHeadingDepth.length - 1 : model.data.rowHeadingDepth.length - model.data.rowHeadingMemberCount - 1)"
                        [class.blank]="r !== (model.showDimension ? model.data.rowHeadingDepth.length - 1 : model.data.rowHeadingDepth.length - model.data.rowHeadingMemberCount - 1)">
                    </div>
                </ng-container>

                <ng-container *ngFor="let c of model.data.colHeadings; trackBy: trackByFn; let colIdx = index">
                    <div class="piv-grid-row-col-heading"
                         [class.piv-span]="c[i].span"
                         [class.piv-cell-bottom]="c[i].bottom"
                         [class.piv-spacer]="c[i].spacer"
                         [class.piv-spacer-edge]="c[i].spacerEdge"
                         [class.piv-label]="c[i].label"
                         [class.piv-total]="c[i].total"
                         [class.summary]="c[i].isSummary">
                        {{c[i].label}}
                        <div *ngIf="c[i].measureName"
                             class="piv-grid-row-col-heading-summary-measure summary">{{c[i].measureName}}</div>
                        <fui-link-button *ngIf="c[i].openStatus === 'closed'" [title]="'+'"
                                         (click)="model.drillColumn(c[i].name, colIdx, i)"></fui-link-button>
                        <fui-link-button *ngIf="c[i].openStatus === 'open'" [title]="'-'"
                                         (click)="model.drillUpColumn(c[i].name, c[i].index, colIdx, i)"></fui-link-button>

                        <div *ngIf="c[i].noChildData" class="piv-grid-heading-no-data">{{"wbo.bi.message.noData" |
                            translate}}
                        </div>

                        <ng-container
                            *ngIf="!model.showDimension && i > 0 && !c[i].openStatus && c[i-1].index === 0 && (c[i-1].openStatus === 'closed' || c[i].total && !c[i].isSummary)">
                            {{c[i - 1].label}}
                            <fui-link-button *ngIf="c[i-1].openStatus === 'closed'" [title]="'+'"
                                             (click)="model.drillColumn(c[i-1].name, colIdx, i-1)"></fui-link-button>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <div class="piv-grid-row" *ngFor="let r of model.data.rowHeadings; trackBy: trackByFn; let rowIdx = index">
            <ng-container *ngFor="let i of model.data.rowHeadingDepth; trackBy: trackByFn">
                <div
                    *ngIf="model.showDimension || r[i].index !== 0 || (!model.data.rowHeadings[0][i + 1] || model.data.rowHeadings[0][i + 1].index === 0 || model.data.rowHeadings[0][i + 1].isSummary)"
                    class="piv-grid-row-heading"
                    [class.piv-span]="r[i].span"
                    [class.piv-cell-bottom]="r[i].bottom"
                    [class.piv-spacer]="r[i].spacer"
                    [class.piv-spacer-edge]="r[i].spacerEdge"
                    [class.piv-label]="r[i].label"
                    [class.piv-total]="r[i].total"
                    [class.summary]="r[i].isSummary">
                    {{r[i].label}}
                    <fui-link-button *ngIf="r[i].openStatus === 'closed'" [title]="'+'"
                                     (click)="model.drillRow(r[i].name, rowIdx, i)"></fui-link-button>
                    <fui-link-button *ngIf="r[i].openStatus === 'open'" [title]="'-'"
                                     (click)="model.drillUpRow(r[i].name, r[i].index, rowIdx, i)"></fui-link-button>

                    <div *ngIf="r[i].noChildData" class="piv-grid-heading-no-data">{{"wbo.bi.message.noData" |
                        translate}}
                    </div>

                    <ng-container
                        *ngIf="!model.showDimension && i > 0 && !r[i].openStatus && r[i-1].index === 0 && !r[i].isSummary && (r[i-1].openStatus === 'closed' || r[i].total)">
                        {{r[i - 1].label}}
                        <fui-link-button *ngIf="r[i-1].openStatus === 'closed'" [title]="'+'"
                                         (click)="model.drillRow(r[i-1].name, rowIdx, i-1)"></fui-link-button>
                    </ng-container>
                </div>
            </ng-container>
            <div class="piv-grid-row-data"
                 *ngFor="let c of model.data.colHeadings; trackBy: trackByFn; let colIdx = index"
                 [class.piv-total]="model.data.isTotalColumn(colIdx) || model.data.isTotalRow(rowIdx)">
                <ng-container [ngSwitch]="model.data.getMeasureType(colIdx)">
                    <div *ngSwitchCase="'CURRENCY'">
                        {{model.data.values[colIdx][rowIdx] | wbo_currency}}
                    </div>
                    <div *ngSwitchCase="'PERCENTAGE'">
                        <ng-container *ngIf="model.data.values[colIdx][rowIdx]">
                            {{(model.data.values[colIdx][rowIdx] | number) + "%"}}
                        </ng-container>
                    </div>
                    <div *ngSwitchCase="'CALCULATED_PERCENTAGE'">
                        <ng-container *ngIf="model.data.values[colIdx][rowIdx]">
                            {{(model.data.values[colIdx][rowIdx] | number) + "%"}}
                        </ng-container>
                    </div>
                    <div *ngSwitchCase="'SECONDS'">
                        {{model.data.values[colIdx][rowIdx] | seconds}}
                    </div>
                    <div *ngSwitchDefault>
                        {{model.data.values[colIdx][rowIdx] | number}}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
